export default "__VITE_PUBLIC_ASSET__6fb78089__"